import React, { lazy } from 'react';
import { Gift } from 'lucide-react';
export function BonusBundle() {
  const bonuses = [{
    image: 'https://cdn.magicpatterns.com/uploads/21ZVwKxWDepopxGozfBEZf/Bono_1.jpg',
    title: 'Chef Peludo',
    value: '$29',
    desc: 'Recetas caseras balanceadas, fáciles y rápidas que tu mascota va a devorar.'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/piJPcCyqFRkA12SheB1S6H/Bono_2.jpg',
    title: 'Botiquín de Emergencia',
    value: '$19',
    desc: 'Cómo actuar en los primeros minutos ante una emergencia y qué tener siempre a mano.'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/uSRCUqbeo23euUtVQjGxHA/Bono_3.jpg',
    title: 'Paz en la Manada',
    value: '$49',
    desc: 'El método para que perros y gatos convivan en armonía bajo el mismo techo.'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/dcvFj7xFprwBmzAUPtXpVM/Bono_4.jpg',
    title: 'El Código de Obediencia',
    value: '$15',
    desc: 'Las claves de atención y conexión para una obediencia natural, sin gritos ni castigos.'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/5P3qk5rs3LczYFqnhU7nbM/Bono_5.jpg',
    title: 'Farmacia Natural',
    value: '$25',
    desc: 'Sanación integral desde tu despensa: remedios caseros con respaldo holístico.'
  }];
  return <section className="py-24 bg-sage-dark text-white overflow-hidden relative" data-id="element-12">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" data-id="element-13"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-terracotta/10 rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2" data-id="element-14"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-15">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-16">
          <div className="inline-flex items-center space-x-2 px-4 py-2 rounded-full bg-white/10 text-white text-sm font-medium mb-6" data-id="element-17">
            <Gift className="w-4 h-4" data-id="element-18" />
            <span data-id="element-19">Bonos Exclusivos</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6" data-id="element-20">
            Llévate todo este arsenal de salud{' '}
            <span className="text-terracotta-light italic" data-id="element-21">GRATIS</span> hoy
          </h2>
          <p className="text-lg text-white/80" data-id="element-22">
            Al adquirir "Más Años Juntos" hoy, también recibes estos 5 bonos
            premium valorados en $137 USD sin costo adicional.
          </p>
        </div>

        {/* Mobile: 2-column grid. Tablet+: horizontal scroll */}
        <div className="grid grid-cols-2 gap-3 md:hidden" data-id="element-23">
          {bonuses.map((bonus, i) => <div key={i} className="bg-white/10 backdrop-blur-md rounded-2xl overflow-hidden border border-white/20 flex flex-col" data-id="element-24">
              <div className="h-20 w-full overflow-hidden bg-white/5" data-id="element-25">
                <img src={bonus.image} alt={bonus.title} width={400} height={160} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-26" />
              </div>
              <div className="p-4 flex flex-col flex-1" data-id="element-27">
                <div className="text-terracotta-light font-bold text-[10px] mb-1 uppercase tracking-wider" data-id="element-28">
                  Bono #{i + 1} • {bonus.value}
                </div>
                <h3 className="text-sm font-bold mb-2 leading-tight" data-id="element-29">
                  {bonus.title}
                </h3>
                <p className="text-white/70 text-xs leading-relaxed" data-id="element-30">
                  {bonus.desc}
                </p>
              </div>
            </div>)}
        </div>

        <div className="hidden md:flex overflow-x-auto pb-8 gap-6 snap-x snap-mandatory hide-scrollbar" data-id="element-31">
          {bonuses.map((bonus, i) => <div key={i} className="min-w-[320px] flex-none snap-center bg-white/10 backdrop-blur-md rounded-3xl overflow-hidden border border-white/20 hover:bg-white/15 transition-colors flex flex-col" data-id="element-32">
              <div className="aspect-square w-full overflow-hidden bg-white/5" data-id="element-33">
                <img src={bonus.image} alt={bonus.title} width={400} height={400} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-34" />
              </div>
              <div className="p-6 flex flex-col flex-1" data-id="element-35">
                <div className="text-terracotta-light font-bold text-sm mb-2 uppercase tracking-wider" data-id="element-36">
                  Bono #{i + 1} • Valor {bonus.value}
                </div>
                <h3 className="text-xl font-bold mb-3 leading-tight" data-id="element-37">
                  {bonus.title}
                </h3>
                <p className="text-white/70 text-sm leading-relaxed" data-id="element-38">
                  {bonus.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}